import React, { useEffect, useState, useCallback } from 'react';
import './DashboardNovoAnuncioFTP.scss';
import { useAuth } from '../../../../context/AuthContext';
import api from '../../../../config/configApi';
// import * as Photos from '../../../../services/photos';
import { logError, logUsuarioForm } from '../../../../services/logService';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Box, Breadcrumbs, Button, Chip, FormControl, FormHelperText, FormLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { styled, emphasize } from '@mui/material/styles';
import { MdClear, MdHome, MdImage } from 'react-icons/md';
import { NumericFormat } from 'react-number-format';
import Resizer from 'react-image-file-resizer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { isEmpty } from 'lodash';
import toast from 'react-hot-toast';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    return {
        backgroundColor: theme.palette.grey[100],
        height: theme.spacing(3),
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(theme.palette.grey[100], 0.06),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.06),
            }),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(theme.palette.grey[100], 0.12),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.12),
            }),
        },
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    };
});

const CustomFormControl = styled(FormControl)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main, // Cor da borda ao focar
        },
    },
    '& .MuiInputLabel-root': {
        color: theme.palette.text.secondary, // Cor do label padrão
        '&.Mui-focused': {
            color: theme.palette.primary.main, // Cor do label ao focar
        },
    },
}));

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 500,
    marginBottom: '5px',
}));

function DashboardNovoAnuncioFTP() {
    const { user } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    // Estado de foco
    const [anoFabFocused, setAnoFabFocused] = useState(null);
    const [anoModeloFocused, setAnoModeloFocused] = useState(null);
    const [modeloFocused, setModeloFocused] = useState(null);
    const [kmFocused, setKmFocused] = useState(null);
    const [valorFocused, setValorFocused] = useState(null);
    const [observacaoFocused, setObservacaoFocused] = useState(null);

    // Estado para imagens
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [previewURLs, setPreviewURLs] = useState([]);
    const [uploadError, setUploadError] = useState(null);
    const maxImagens = 15;

    // Estado para controle de disable botoes e inputs durante submit
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [disableDeleteImg, setDisableDeleteImg] = useState(false);

    const [userForm, setUserForm] = useState({
        categoria_id: '',
        marca_id: '',
        ano_fabricacao: null,
        ano_modelo: null,
        tipo: '',
        modelo: '',
        direcao: '',
        cor: '',
        combustivel: '',
        cambio: '',
        tracao: '',
        carroceria: '',
        km: 0,
        valor: 0,
        observacao: '',
    })
    const [error, setError] = useState({
        categoria_id: null,
        marca_id: null,
        ano_fabricacao: null,
        ano_modelo: null,
        tipo: null,
        modelo: null,
        direcao: null,
        cor: null,
        combustivel: null,
        cambio: null,
        tracao: null,
        carroceria: null,
        km: null,
        valor: null,
        observacao: null,
        imagem: null,
    });

    // Log de acesso ao formulario
    useEffect(() => {
        const logData = {
            email: user?.email,
            formulario: location.pathname,
        };

        const fetchLogUserForm = async () => {
            await logUsuarioForm(logData);
        };

        // Condição para disparar o log: usuário autenticado e informações essenciais disponíveis
        if (user && user.email) { // user.id é garantido se user.email existe no seu contexto
            fetchLogUserForm();
        }
    }, [user, location.pathname]);

    // Funcoes de visibilidade dos campos
    const showFields = userForm.categoria_id !== '';
    // CATEGORIA CARRETA
    const showDirecao = userForm.categoria_id !== 2;
    const showCombustivel = userForm.categoria_id !== 2;
    const showCambio = userForm.categoria_id !== 2;
    const showKm = userForm.categoria_id !== 2;
    // CATEGORIA CARRO E CARRETA
    const showTracao = userForm.categoria_id !== 3 && userForm.categoria_id !== 2;
    const showCarroceria = userForm.categoria_id !== 3 && userForm.categoria_id !== 2;
    // CATEGORIA CAMINHAO E CARRO
    const showTipo = userForm.categoria_id !== 1 && userForm.categoria_id !== 3;
    const showModeloSelect = userForm.categoria_id !== 1 && userForm.categoria_id !== 3;

    const handleChange = (e) => {
        setUserForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) e.preventDefault()
    }

    const handleNumericInputChange = (values, name) => {
        setUserForm((prev) => ({
            ...prev,
            [name]: values.value ? parseFloat(values.value) : '', // Mantém como string para KM
        }));
    };

    const handleImageChange = async (event) => {
        const files = Array.from(event.target.files);

        if (files.length === 0) {
            return
        }

        let totalSelecionadas = selectedFiles.length + files.length;

        if (totalSelecionadas > maxImagens) {
            toast(`Selecione no máximo ${maxImagens} imagens!`, { icon: '⚠️' });
            setError(prev => ({ ...prev, imagem: `Você só pode selecionar no máximo ${maxImagens} imagens.` }));
            return;
        }
        setError(prev => ({ ...prev, imagem: null })); // Limpa erro de imagem se houver


        const resizedFilesPromises = files.map(file => {
            return new Promise((resolve, reject) => {
                Resizer.imageFileResizer(
                    file,
                    1920,
                    1440,
                    'JPG',
                    100, // Qualidade ligeiramente reduzida para otimização
                    0,
                    (resizedFile) => {
                        resolve(resizedFile);
                    },
                    'blob'
                );
            });
        });

        try {
            const newResizedFiles = await Promise.all(resizedFilesPromises);
            const newPreviewURLs = newResizedFiles.map(file => URL.createObjectURL(file));

            setSelectedFiles((prev) => [...prev, ...newResizedFiles]);
            setPreviewURLs((prev) => [...prev, ...newPreviewURLs]);
        } catch (err) {
            toast.error('Erro ao processar algumas imagens.');
        }
    };

    const handleDeleteImage = (indexToDelete) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
        setPreviewURLs((prevURLs) => {
            const urlToDelete = prevURLs[indexToDelete];
            URL.revokeObjectURL(urlToDelete); // Libera memória
            return prevURLs.filter((_, index) => index !== indexToDelete);
        });
        if (selectedFiles.length - 1 < maxImagens) {
            setError(prev => ({ ...prev, imagem: null })); // Limpa erro se voltar a estar dentro do limite
        }
    }

    // Função de validação centralizada
    const validateForm = useCallback(() => {
        let currentErrors = {};
        let formIsValid = true;

        // Validações comuns a todas as categorias
        if (userForm.categoria_id === '') {
            currentErrors.categoria_id = 'Selecione a categoria';
            formIsValid = false;
        }
        if (userForm.marca_id === '') {
            currentErrors.marca_id = 'Selecione uma marca';
            formIsValid = false;
        }
        if (isEmpty(userForm.ano_fabricacao) || userForm.ano_fabricacao.length < 4 || isNaN(Number(userForm.ano_fabricacao))) {
            currentErrors.ano_fabricacao = 'Informe o ano da fabricação (4 dígitos)';
            formIsValid = false;
        } else if (Number(userForm.ano_fabricacao) > new Date().getFullYear() + 1 || Number(userForm.ano_fabricacao) < 1900) {
            currentErrors.ano_fabricacao = 'Ano inválido';
            formIsValid = false;
        }
        if (isEmpty(userForm.ano_modelo) || userForm.ano_modelo.length < 4 || isNaN(Number(userForm.ano_modelo))) {
            currentErrors.ano_modelo = 'Informe o ano modelo (4 dígitos)';
            formIsValid = false;
        } else if (Number(userForm.ano_modelo) < Number(userForm.ano_fabricacao) || Number(userForm.ano_modelo) > new Date().getFullYear() + 1) {
            currentErrors.ano_modelo = 'Ano modelo inválido';
            formIsValid = false;
        }
        if (isEmpty(userForm.modelo)) {
            currentErrors.modelo = 'Informe o modelo';
            formIsValid = false;
        }
        if (isEmpty(userForm.cor)) {
            currentErrors.cor = 'Informe a cor';
            formIsValid = false;
        }
        if (isEmpty(String(userForm.km)) || userForm.km < 0) { // KM pode ser 0
            currentErrors.km = 'Informe a km (deixe 0 para consulte)';
            formIsValid = false;
        }
        if (isEmpty(String(userForm.valor)) || userForm.valor < 0) { // Valor pode ser 0
            currentErrors.valor = 'Informe o valor (deixe 0 para consulte)';
            formIsValid = false;
        }
        if (isEmpty(userForm.observacao)) {
            currentErrors.observacao = 'Informe a observação';
            formIsValid = false;
        }
        if (selectedFiles.length === 0) {
            currentErrors.imagem = 'Selecione as imagens do anúncio';
            formIsValid = false;
        } else if (selectedFiles.length > maxImagens) {
            currentErrors.imagem = `Selecione até ${maxImagens} imagens!!!`;
            formIsValid = false;
        }

        // Validações específicas por categoria
        const categoriaId = Number(userForm.categoria_id);
        if (categoriaId === 1) { // Caminhão
            if (isEmpty(userForm.combustivel)) { currentErrors.combustivel = 'Informe o combustível'; formIsValid = false; }
            if (isEmpty(userForm.cambio)) { currentErrors.cambio = 'Informe o câmbio'; formIsValid = false; }
            if (isEmpty(userForm.direcao)) { currentErrors.direcao = 'Informe a direção'; formIsValid = false; }
            if (isEmpty(userForm.tracao)) { currentErrors.tracao = 'Informe a tração'; formIsValid = false; }
            if (isEmpty(userForm.carroceria)) { currentErrors.carroceria = 'Informe a carroceria'; formIsValid = false; }
        } else if (categoriaId === 2) { // Carreta
            // Campos não aplicáveis são removidos no updatedUserForm, não validamos aqui
            if (isEmpty(userForm.tipo)) { currentErrors.tipo = 'Informe o tipo'; formIsValid = false; }
        } else if (categoriaId === 3) { // Carro
            // Campos não aplicáveis são removidos no updatedUserForm, não validamos aqui
            if (isEmpty(userForm.combustivel)) { currentErrors.combustivel = 'Informe o combustível'; formIsValid = false; }
            if (isEmpty(userForm.cambio)) { currentErrors.cambio = 'Informe o câmbio'; formIsValid = false; }
            if (isEmpty(userForm.direcao)) { currentErrors.direcao = 'Informe a direção'; formIsValid = false; }
        }        

        setError(currentErrors); // Atualiza todos os erros de uma vez
        return formIsValid;
    }, [userForm, selectedFiles, maxImagens]); // Depende do userForm e selectedFiles para reavaliar a validação

    // Limpa erros ao mudar categoria
    useEffect(() => {
        if (userForm.categoria_id === 1) { // Caminhao
            setError(prev => ({
                ...prev,
                tipo: null
            }));
        }
        if (userForm.categoria_id === 2) { // Carreta
            setError(prev => ({
                ...prev,
                direcao: null, combustivel: null, cambio: null, km: null, tracao: null, carroceria: null
            }));
        } else if (userForm.categoria_id === 3) { // Carro
            setError(prev => ({
                ...prev,
                tipo: null, tracao: null, carroceria: null
            }));
        }
    }, [userForm.categoria_id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsButtonDisabled(true);
        setDisableDeleteImg(true);

        let formDataToSubmit = { ...userForm };

        formDataToSubmit.modelo = userForm.modelo.toUpperCase();
        formDataToSubmit.ano_fabricacao = parseInt(userForm.ano_fabricacao);
        formDataToSubmit.ano_modelo = parseInt(userForm.ano_modelo);

        // Remove campos baseados na categoria antes da validação final para o backend
        const categoriaId = Number(formDataToSubmit.categoria_id);
        if (categoriaId === 1) { // Caminhao
            delete formDataToSubmit.tipo;
        }
        if (categoriaId === 2) { // Carreta
            delete formDataToSubmit.direcao;
            delete formDataToSubmit.combustivel;
            delete formDataToSubmit.cambio;
            delete formDataToSubmit.km;
            delete formDataToSubmit.tracao;
            delete formDataToSubmit.carroceria;
        } else if (categoriaId === 3) { // Carro
            delete formDataToSubmit.tipo;
            delete formDataToSubmit.tracao;
            delete formDataToSubmit.carroceria;
        }

        // Valida o formulário
        const formIsValid = validateForm();
        if (!formIsValid) {
            toast.error('Por favor, corrija os erros no formulário.');
            setIsButtonDisabled(false); // Reabilita o botão
            setDisableDeleteImg(false);
            return;
        }

        // Garante que o usuario_id esteja setado. Caso não esteja, é um erro crítico.
        if (formDataToSubmit.usuario_id === null) {
            toast.error('Erro: ID do usuário não disponível. Tente novamente.');
            await logError({
                email: user?.email || 'N/A',
                log_erro: 'Usuario_id nulo no momento do submit do formulário de anúncio.',
                formulario: location.pathname,
            });
            setIsButtonDisabled(false);
            setDisableDeleteImg(false);
            return;
        }

        let createdAnuncioId = null;
        let uploadFolderName = null;
        let uploadedImageDetails = [];
        let hasCriticalError = false;

        const toastId = toast.loading('Salvando informações do veículo...');

        // 1. CRIAR VEICULO NO BACK END E PEGAR ID
        try {
            const response = await api.post('/api/anuncio', formDataToSubmit);
            if (response.status === 201) {
                createdAnuncioId = response.data.id;
                toast.success('Informações do veículo salvas!', { id: toastId });
            } else {
                const errorMessage = response?.data?.message || 'Erro desconhecido ao criar veículo';
                toast.error(`Erro ao criar veículo: ${errorMessage}`, { id: toastId });
                await logError({
                    email: user?.email || 'N/A',
                    log_erro: `Erro ao criar veículo: ${errorMessage}`,
                    formulario: location.pathname || 'N/A',
                });
                hasCriticalError = true;
            }
        } catch (err) {
            const errorMessage = err.response?.data?.msg || err.message || 'Erro desconhecido';
            if (err.status !== 500) {
                toast(`${errorMessage}`, { id: toastId, icon: '⚠️', style: { background: '#fff4e5', color: '#663c00' } });
            } else {
                toast.error(`Erro inesperado ao criar veículo: ${errorMessage}`, { id: toastId });
            }
            await logError({
                email: user?.email || 'N/A',
                log_erro: `Erro inesperado ao criar veículo: ${errorMessage}`,
                formulario: location.pathname || 'N/A',
            });
            hasCriticalError = true;
        }        

        // 2. ENVIANDO AS IMAGENS PARA O BACK, GRAVAR NO FTP E GRAVAR NO BANCO
        if (!hasCriticalError && createdAnuncioId) {
            if (selectedFiles.length > 0) {
                try {
                    toast.loading('Salvando imagens do veículo...', { id: toastId });
                    const formData = new FormData();

                    for (let i = 0; i < selectedFiles.length; i++) {
                        formData.append('files', selectedFiles[i]);
                    }

                    await api.post(`/api/imagens-ftp/${createdAnuncioId}`, formData);
                    toast.success('Imagens salvas com sucesso!', { id: toastId });
                } catch (err) {
                    const errorMessage = err.response?.data?.msg || err.message || 'Erro salvar imagens';
                    toast.error(`Falha no upload das imagens: ${errorMessage}`, { id: toastId });
                    await logError({
                        email: user?.email || 'N/A',
                        log_erro: `Falha no upload de imagens do Veículo ${createdAnuncioId}: ${errorMessage}`,
                        formulario: location.pathname,
                    });
                    hasCriticalError = true; // Mark critical error
                }
            }
        }

        // 3. REDIRECIONANDO
        if (!hasCriticalError && createdAnuncioId) {
            toast.success('Veículo criado e imagens salvas com sucesso!', { id: toastId, duration: 4000 });
            setTimeout(() => navigate(`/dashboard/anuncio/${createdAnuncioId}/detalhes`), 2000);
        } else {
            // If a critical error occurred, ensure the toast reflects a final error state
            // It should already be an error from previous steps, but this is a fallback.
            toast.error('O processo de criação do veículo falhou.');
        }

        // 2. SALVANDO IMAGENS NO FIREBASE
        // if (!hasCriticalError && createdAnuncioId) {
        //     if (selectedFiles.length > 0) {
        //         try {
        //             uploadFolderName = v4().substring(0, 10);
        //             let isPathExisting = true;
        //             const maxRetries = 5;

        //             for (let i = 0; i < maxRetries && isPathExisting; i++) {
        //                 isPathExisting = await Photos.pathExists(uploadFolderName);
        //                 if (isPathExisting) {
        //                     uploadFolderName = v4().substring(0, 10);
        //                 }
        //             }

        //             if (isPathExisting) {
        //                 const errorMessage = 'Não foi possível gerar um nome de pasta único para o upload de imagens.';
        //                 toast.error(errorMessage, { id: toastId });
        //                 await logError({
        //                     email: user?.email || 'N/A',
        //                     log_erro: `Erro ao gerar nome de pasta único para o upload de imagens do Veículo ${createdAnuncioId}: ${errorMessage}`,
        //                     formulario: location.pathname,
        //                 });
        //                 hasCriticalError = true; // Mark critical error
        //             } else {
        //                 toast.loading('Enviando imagens para a nuvem...', { id: toastId });
        //                 // Promise.all to send all images concurrently
        //                 uploadedImageDetails = await Promise.all(
        //                     selectedFiles.map(async (file) => {
        //                         return await Photos.uploadImage(uploadFolderName, file);
        //                     })
        //                 );
        //                 toast.success('Imagens salvas na nuvem com sucesso!', { id: toastId });
        //             }
        //         } catch (err) {
        //             const errorMessage = err.message || 'Erro ao enviar imagens para a nuvem.';
        //             toast.error(`Falha no upload das imagens: ${errorMessage}`, { id: toastId });
        //             await logError({
        //                 email: user?.email || 'N/A',
        //                 log_erro: `Falha no upload de imagens para o Firebase do Veículo ${createdAnuncioId}: ${errorMessage}`,
        //                 formulario: location.pathname,
        //             });
        //             hasCriticalError = true; // Mark critical error
        //             uploadedImageDetails = []; // Clear uploaded details if there was an error
        //         }
        //     } else {
        //         toast.success('Nenhuma imagem para enviar para a nuvem.', { id: toastId });
        //     }
        // }

        // 3. SALVANDO INFORMACOES DAS IMAGENS NO BANCO
        // if (!hasCriticalError && createdAnuncioId && uploadedImageDetails.length > 0) {
        //     try {
        //         toast.loading('Associando imagens ao veículo no banco...', { id: toastId });
        //         await api.post(`/api/imagens-firebase/${createdAnuncioId}`, { imagesToAdd: uploadedImageDetails });
        //         toast.success('Imagens associadas ao veículo com sucesso!', { id: toastId });
        //     } catch (err) {
        //         const errorMessage = err.response?.data?.msg || err.message || 'Erro ao associar imagens ao anúncio.';
        //         toast.error(`Falha ao associar imagens ao veículo: ${errorMessage}`, { id: toastId });
        //         await logError({
        //             email: user?.email || 'N/A',
        //             log_erro: `Falha ao associar imagens do Veículo ${createdAnuncioId} no banco: ${errorMessage}`,
        //             formulario: location.pathname,
        //         });
        //         hasCriticalError = true; // Mark critical error
        //     }
        // }
    }

    return (
        <>
            <div className='card shadow border-0 w-100 flex-row p-4 res-col'>
                <h5 className='mb-0'>Novo anúncio</h5>
                <Breadcrumbs
                    aria-label='breadcrumb'
                    className='ms-auto breadcrumbs_'
                >
                    <StyledBreadcrumb label='Dashboard' icon={<MdHome fontSize='small' />} />
                    <StyledBreadcrumb label='Anúncio' />
                    <StyledBreadcrumb label='Novo' />
                </Breadcrumbs>
            </div>
            {!user.criar && (
                <Alert severity='warning'>Seu usuário não possui permissão para criar!</Alert>
            )}
            {user.criar && (
                <Box
                    className='form'
                    component='form'
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card p-4 mt-0'>
                                <h5 className='mb-4'>Informações</h5>

                                <div className='row'>
                                    <div className='col'>
                                        <CustomFormControl
                                            className='mb-4'
                                            fullWidth
                                        >
                                            <FormLabel
                                                htmlFor='categoria'
                                                sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                error={error?.categoria_id}
                                            >
                                                Categoria
                                            </FormLabel>
                                            <Select
                                                required
                                                labelId='categoria-label'
                                                id='categoria'
                                                name='categoria_id'
                                                displayEmpty
                                                value={userForm.categoria_id}
                                                error={error?.categoria_id}
                                                onChange={handleChange}
                                                input={<OutlinedInput id='categoria-input' />}
                                                color={error?.categoria_id ? 'error' : 'primary'}
                                                disabled={isButtonDisabled}
                                            >
                                                <MenuItem value=''>
                                                    <em>Selecione</em>
                                                </MenuItem>
                                                <MenuItem value={1}>CAMINHÃO</MenuItem>
                                                <MenuItem value={2}>CARRETA</MenuItem>
                                                <MenuItem value={3}>CARRO</MenuItem>
                                            </Select>
                                            {error?.categoria_id && (
                                                <FormHelperText error>{error?.categoria_id}</FormHelperText>
                                            )}
                                        </CustomFormControl>
                                    </div>
                                    {showFields && (
                                        <>
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='marca'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.marca_id}
                                                    >
                                                        Marca
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='marca-label'
                                                        id='marca'
                                                        name='marca_id'
                                                        variant='outlined'
                                                        displayEmpty
                                                        value={userForm.marca_id}
                                                        error={error?.marca_id}
                                                        helperText={error?.marca_id}
                                                        color={error?.marca_id ? 'error' : 'primary'}
                                                        input={<OutlinedInput id='marca-input' />}
                                                        onChange={handleChange}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={1}>BMW</MenuItem>
                                                        <MenuItem value={2}>CHEVROLET</MenuItem>
                                                        <MenuItem value={3}>DAF</MenuItem>
                                                        <MenuItem value={4}>FACCHINI</MenuItem>
                                                        <MenuItem value={5}>FORD</MenuItem>
                                                        <MenuItem value={6}>GUERRA</MenuItem>
                                                        <MenuItem value={7}>HONDA</MenuItem>
                                                        <MenuItem value={8}>HYUNDAI</MenuItem>
                                                        <MenuItem value={9}>IVECO</MenuItem>
                                                        <MenuItem value={10}>JEEP</MenuItem>
                                                        <MenuItem value={11}>KIA</MenuItem>
                                                        <MenuItem value={12}>LAND ROVER</MenuItem>
                                                        <MenuItem value={13}>LIBRELATO</MenuItem>
                                                        <MenuItem value={14}>MAN</MenuItem>
                                                        <MenuItem value={15}>MERCEDES-BENZ</MenuItem>
                                                        <MenuItem value={16}>MITSUBISHI</MenuItem>
                                                        <MenuItem value={17}>NISSAN</MenuItem>
                                                        <MenuItem value={18}>NOMA</MenuItem>
                                                        <MenuItem value={19}>PASTRE</MenuItem>
                                                        <MenuItem value={20}>RAM</MenuItem>
                                                        <MenuItem value={21}>RANDON</MenuItem>
                                                        <MenuItem value={22}>RODOFLEX</MenuItem>
                                                        <MenuItem value={23}>ROSSETTI</MenuItem>
                                                        <MenuItem value={24}>SCANIA</MenuItem>
                                                        <MenuItem value={25}>TOYOTA</MenuItem>
                                                        <MenuItem value={26}>VOLKSWAGEN</MenuItem>
                                                        <MenuItem value={27}>VOLVO</MenuItem>
                                                        <MenuItem value={28}>AIZI</MenuItem>
                                                    </Select>
                                                    {error?.marca_id && (
                                                        <FormHelperText error>{error.marca_id}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='ano_fabricacao'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: anoFabFocused ? 'primary.main' : '' }}
                                                        error={error?.ano_fabricacao}
                                                    >
                                                        Ano fabricação
                                                    </FormLabel>
                                                    <TextField
                                                        required
                                                        id='ano_fabricacao'
                                                        name='ano_fabricacao'
                                                        inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                        variant='outlined'
                                                        error={error?.ano_fabricacao}
                                                        helperText={error?.ano_fabricacao}
                                                        color={error?.ano_fabricacao ? 'error' : 'primary'}
                                                        onChange={handleChange}
                                                        onKeyPress={handleKeyPress}
                                                        onFocus={() => setAnoFabFocused(!anoFabFocused)}
                                                        onBlur={() => setAnoFabFocused(!anoFabFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='ano_modelo'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: anoModeloFocused ? 'primary.main' : '' }}
                                                        error={error?.ano_modelo}
                                                    >
                                                        Ano modelo
                                                    </FormLabel>
                                                    <TextField
                                                        required
                                                        id='ano_modelo'
                                                        name='ano_modelo'
                                                        inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                        variant='outlined'
                                                        error={error?.ano_modelo}
                                                        helperText={error?.ano_modelo}
                                                        color={error?.ano_modelo ? 'error' : 'primary'}
                                                        onChange={handleChange}
                                                        onKeyPress={handleKeyPress}
                                                        onFocus={() => setAnoModeloFocused(!anoModeloFocused)}
                                                        onBlur={() => setAnoModeloFocused(!anoModeloFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                        </>
                                    )}
                                </div>

                                {showFields && (
                                    <div className='row'>
                                        {showTipo && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='tipo'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.tipo}
                                                    >
                                                        Tipo
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='tipo-label'
                                                        id='tipo'
                                                        name='tipo'
                                                        value={userForm.tipo}
                                                        error={error?.tipo}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='tipo-input' />}
                                                        color={error?.tipo ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'BITREM'}>BITREM</MenuItem>
                                                        <MenuItem value={'BITREM 9 EIXOS'}>BITREM 9 EIXOS</MenuItem>
                                                        <MenuItem value={'DOLLY'}>DOLLY</MenuItem>
                                                        <MenuItem value={'JULIETA'}>JULIETA</MenuItem>
                                                        <MenuItem value={'RODOTREM'}>RODOTREM</MenuItem>
                                                        <MenuItem value={'SEMI-REBOQUE'}>SEMI-REBOQUE</MenuItem>
                                                        <MenuItem value={'TRITREM'}>TRITREM</MenuItem>
                                                    </Select>
                                                    {error?.tipo && (
                                                        <FormHelperText error>{error.tipo}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}

                                        {showModeloSelect ? (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='modelo'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.modelo}
                                                    >
                                                        Modelo
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='modelo-label'
                                                        id='modelo'
                                                        name='modelo'
                                                        value={userForm.modelo}
                                                        error={error?.modelo}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='modelo-input' />}
                                                        color={error?.modelo ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value='ALGODOEIRO'>ALGODOEIRO</MenuItem>
                                                        <MenuItem value='AUTO ESCOLA'>AUTO ESCOLA</MenuItem>
                                                        <MenuItem value='BASCULANTE'>BASCULANTE</MenuItem>
                                                        <MenuItem value='BAU BEBIDAS'>BAU BEBIDAS</MenuItem>
                                                        <MenuItem value='BAU FURGAO'>BAU FURGAO</MenuItem>
                                                        <MenuItem value='BAU SIDER'>BAU SIDER</MenuItem>
                                                        <MenuItem value='BOBINEIRO'>BOBINEIRO</MenuItem>
                                                        <MenuItem value='BOIADEIRO'>BOIADEIRO</MenuItem>
                                                        <MenuItem value='CANAVIEIRO'>CANAVIEIRO</MenuItem>
                                                        <MenuItem value='CARGA SECA'>CARGA SECA</MenuItem>
                                                        <MenuItem value='CARREGA TUDO'>CARREGA TUDO</MenuItem>
                                                        <MenuItem value='CAVAQUEIRA'>CAVAQUEIRA</MenuItem>
                                                        <MenuItem value='CEGONHA'>CEGONHA</MenuItem>
                                                        <MenuItem value='CEREALEIRO'>CEREALEIRO</MenuItem>
                                                        <MenuItem value='CEREALEIRO HOPPER'>CEREALEIRO HOPPER</MenuItem>
                                                        <MenuItem value='CHASSI'>CHASSI</MenuItem>
                                                        <MenuItem value='CONTAINER'>CONTAINER</MenuItem>
                                                        <MenuItem value='DOLLY'>DOLLY</MenuItem>
                                                        <MenuItem value='DOLLY 1 EIXO'>DOLLY 1 EIXO</MenuItem>
                                                        <MenuItem value='DOLLY 2 EIXO'>DOLLY 2 EIXO</MenuItem>
                                                        <MenuItem value='EXTENSIVA'>EXTENSIVA</MenuItem>
                                                        <MenuItem value='FLORESTAL'>FLORESTAL</MenuItem>
                                                        <MenuItem value='FRANGUEIRA'>FRANGUEIRA</MenuItem>
                                                        <MenuItem value='FRIGORIFICO'>FRIGORIFICO</MenuItem>
                                                        <MenuItem value='GAIOLA de GAS'>GAIOLA de GAS</MenuItem>
                                                        <MenuItem value='GRANELEIRO'>GRANELEIRO</MenuItem>
                                                        <MenuItem value='JULIETA ROLL ON'>JULIETA ROLL ON</MenuItem>
                                                        <MenuItem value='KIT SIDER'>KIT SIDER</MenuItem>
                                                        <MenuItem value='LAGARTIXA'>LAGARTIXA</MenuItem>
                                                        <MenuItem value='PORTA-CONTAINER'>PORTA-CONTAINER</MenuItem>
                                                        <MenuItem value='PRANCHA'>PRANCHA</MenuItem>
                                                        <MenuItem value='REBOQUE FLEX 2 EIXOS'>REBOQUE FLEX 2 EIXOS</MenuItem>
                                                        <MenuItem value='REBOQUE FLEX 3 EIXOS'>REBOQUE FLEX 3 EIXOS</MenuItem>
                                                        <MenuItem value='REBOQUE FLEX 4 EIXOS'>REBOQUE FLEX 4 EIXOS</MenuItem>
                                                        <MenuItem value='Roll ON OFF'>Roll ON OFF</MenuItem>
                                                        <MenuItem value='SEMI REBOQUE FLEX'>SEMI REBOQUE FLEX</MenuItem>
                                                        <MenuItem value='SILO'>SILO</MenuItem>
                                                        <MenuItem value='SUINEIRA'>SUINEIRA</MenuItem>
                                                        <MenuItem value='TANQUE AÇO'>TANQUE AÇO</MenuItem>
                                                        <MenuItem value='TANQUE ALUMINIO'>TANQUE ALUMINIO</MenuItem>
                                                        <MenuItem value='TANQUE GASES GLP'>TANQUE GASES GLP</MenuItem>
                                                        <MenuItem value='TANQUE INOX'>TANQUE INOX</MenuItem>
                                                        <MenuItem value='TANQUE ISOTERMICO'>TANQUE ISOTERMICO</MenuItem>
                                                    </Select>
                                                    {error?.modelo && (
                                                        <FormHelperText error>{error.modelo}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        ) : (
                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='modelo'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: modeloFocused ? 'primary.main' : '' }}
                                                        error={error?.modelo}
                                                    >
                                                        Modelo
                                                    </FormLabel>
                                                    <TextField
                                                        required
                                                        id='modelo'
                                                        name='modelo'
                                                        type='text'
                                                        variant='outlined'
                                                        error={error?.modelo}
                                                        helperText={error?.modelo}
                                                        color={error?.modelo ? 'error' : 'primary'}
                                                        onChange={handleChange}
                                                        onFocus={() => setModeloFocused(!modeloFocused)}
                                                        onBlur={() => setModeloFocused(!modeloFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                        )}

                                        {showDirecao && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='direcao'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.direcao}
                                                    >
                                                        Direção
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='direcao-label'
                                                        id='direcao'
                                                        name='direcao'
                                                        value={userForm.direcao}
                                                        error={error?.direcao}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='direcao-input' />}
                                                        color={error?.direcao ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'MECÂNICA'}>MECÂNICA</MenuItem>
                                                        <MenuItem value={'HIDRÁULICA'}>HIDRÁULICA</MenuItem>
                                                        <MenuItem value={'ELÉTRICA'}>ELÉTRICA</MenuItem>
                                                    </Select>
                                                    {error?.direcao && (
                                                        <FormHelperText error>{error.direcao}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {showFields && (
                                    <div className='row'>
                                        <div className='col'>
                                            <CustomFormControl
                                                className='mb-4'
                                                fullWidth
                                            >
                                                <FormLabel
                                                    htmlFor='cor'
                                                    sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                    error={error?.cor}
                                                >
                                                    Cor
                                                </FormLabel>
                                                <Select
                                                    required
                                                    labelId='cor-label'
                                                    id='cor'
                                                    name='cor'
                                                    value={userForm.cor}
                                                    error={error?.cor}
                                                    displayEmpty
                                                    onChange={handleChange}
                                                    input={<OutlinedInput id='cor-input' />}
                                                    color={error?.cor ? 'error' : 'primary'}
                                                    disabled={isButtonDisabled}
                                                >
                                                    <MenuItem value=''>
                                                        <em>Selecione</em>
                                                    </MenuItem>
                                                    <MenuItem value={'AZUL'}>AZUL</MenuItem>
                                                    <MenuItem value={'AMARELO'}>AMARELO</MenuItem>
                                                    <MenuItem value={'BRANCO'}>BRANCO</MenuItem>
                                                    <MenuItem value={'PRETO'}>PRETO</MenuItem>
                                                    <MenuItem value={'PRATA'}>PRATA</MenuItem>
                                                    <MenuItem value={'BORDO'}>BORDO</MenuItem>
                                                    <MenuItem value={'CINZA'}>CINZA</MenuItem>
                                                    <MenuItem value={'DOURADO'}>DOURADO</MenuItem>
                                                    <MenuItem value={'LARANJA'}>LARANJA</MenuItem>
                                                    <MenuItem value={'MARROM'}>MARROM</MenuItem>
                                                    <MenuItem value={'VERDE'}>VERDE</MenuItem>
                                                    <MenuItem value={'VERMELHO'}>VERMELHO</MenuItem>
                                                    <MenuItem value={'VINHO'}>VINHO</MenuItem>
                                                    <MenuItem value={'ROSA'}>ROSA</MenuItem>
                                                </Select>
                                                {error?.cor && (
                                                    <FormHelperText error>{error.cor}</FormHelperText>
                                                )}
                                            </CustomFormControl>
                                        </div>

                                        {showCombustivel && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='combustivel'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.combustivel}
                                                    >
                                                        Combustível
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='combustivel-label'
                                                        id='combustivel'
                                                        name='combustivel'
                                                        value={userForm.combustivel}
                                                        error={error?.combustivel}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='combustivel-input' />}
                                                        color={error?.combustivel ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'GASOLINA'}>GASOLINA</MenuItem>
                                                        <MenuItem value={'ÁLCOOL'}>ÁLCOOL</MenuItem>
                                                        <MenuItem value={'DIESEL'}>DIESEL</MenuItem>
                                                        <MenuItem value={'FLEX'}>FLEX</MenuItem>
                                                        <MenuItem value={'HÍBRIDO'}>HÍBRIDO</MenuItem>
                                                        <MenuItem value={'ELÉTRICO'}>ELÉTRICO</MenuItem>
                                                    </Select>
                                                    {error?.combustivel && (
                                                        <FormHelperText error>{error.combustivel}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}

                                        {showCambio && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='cambio'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.cambio}
                                                    >
                                                        Câmbio
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='cambio-label'
                                                        id='cambio'
                                                        name='cambio'
                                                        value={userForm.cambio}
                                                        error={error?.cambio}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='cambio-input' />}
                                                        color={error?.cambio ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'AUTOMÁTICO'}>AUTOMÁTICO</MenuItem>
                                                        <MenuItem value={'MANUAL'}>MANUAL</MenuItem>
                                                    </Select>
                                                    {error?.cambio && (
                                                        <FormHelperText error>{error.cambio}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {showFields && (
                                    <div className='row'>
                                        {showTracao && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='tracao'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.tracao}
                                                    >
                                                        Tração
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='tracao-label'
                                                        id='tracao'
                                                        name='tracao'
                                                        value={userForm.tracao}
                                                        error={error?.tracao}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='tracao-input' />}
                                                        color={error?.tracao ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'3/4 4X2'}>3/4 4X2</MenuItem>
                                                        <MenuItem value={'3/4 6X2'}>3/4 6X2</MenuItem>
                                                        <MenuItem value={'3/4 4X4'}>3/4 4X4</MenuItem>
                                                        <MenuItem value={'TOCO 4X2'}>TOCO 4X2</MenuItem>
                                                        <MenuItem value={'TOCO 4X4'}>TOCO 4X4</MenuItem>
                                                        <MenuItem value={'TRUCK 6X2'}>TRUCK 6X2</MenuItem>
                                                        <MenuItem value={'TRAÇADO 6X4'}>TRAÇADO 6X4</MenuItem>
                                                        <MenuItem value={'TRAÇADO 6X6'}>TRAÇADO 6X6</MenuItem>
                                                        <MenuItem value={'BITRUCK 8X2'}>BITRUCK 8X2</MenuItem>
                                                        <MenuItem value={'BITRUCK 8X4'}>BITRUCK 8X4</MenuItem>
                                                    </Select>
                                                    {error?.tracao && (
                                                        <FormHelperText error>{error.tracao}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}

                                        {showCarroceria && (
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='carroceria'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.carroceria}
                                                    >
                                                        Carroceria
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='carroceria-label'
                                                        id='carroceria'
                                                        name='carroceria'
                                                        value={userForm.carroceria}
                                                        error={error?.carroceria}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='carroceria-input' />}
                                                        color={error?.carroceria ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value='CAVALO MECÂNICO'>CAVALO MECÂNICO</MenuItem>
                                                        <MenuItem value='AVES VIVAS'>AVES VIVAS</MenuItem>
                                                        <MenuItem value='BAÚ BEBIDAS'>BAÚ BEBIDAS</MenuItem>
                                                        <MenuItem value='BAÚ FRIGORÍFICO'>BAÚ FRIGORÍFICO</MenuItem>
                                                        <MenuItem value='BAÚ FURGÃO'>BAÚ FURGÃO</MenuItem>
                                                        <MenuItem value='BAÚ SIDER'>BAÚ SIDER</MenuItem>
                                                        <MenuItem value='BAÚ TÉRMICO'>BAÚ TÉRMICO</MenuItem>
                                                        <MenuItem value='BETONEIRA'>BETONEIRA</MenuItem>
                                                        <MenuItem value='BOIADEIRO'>BOIADEIRO</MenuItem>
                                                        <MenuItem value='BOMBA DE CONCRETO'>BOMBA DE CONCRETO</MenuItem>
                                                        <MenuItem value='BOMBEIRO'>BOMBEIRO</MenuItem>
                                                        <MenuItem value='CAÇAMBA BASCULANTE'>CAÇAMBA BASCULANTE</MenuItem>
                                                        <MenuItem value='CAÇAMBA CABINE SUPLEMENTAR'>CAÇAMBA CABINE SUPLEMENTAR</MenuItem>
                                                        <MenuItem value='CEGONHA'>CEGONHA</MenuItem>
                                                        <MenuItem value='CESTO AEREO ISOLADO'>CESTO AEREO ISOLADO</MenuItem>
                                                        <MenuItem value='COMBOIO'>COMBOIO</MenuItem>
                                                        <MenuItem value='CARGA SECA'>CARGA SECA</MenuItem>
                                                        <MenuItem value='CARROCERIA CABINE SUPLEMENTAR'>CARROCERIA CABINE SUPLEMENTAR</MenuItem>
                                                        <MenuItem value='CHASSIS'>CHASSIS</MenuItem>
                                                        <MenuItem value='COLETOR DE LIXO'>COLETOR DE LIXO</MenuItem>
                                                        <MenuItem value='CONTEINER 20 PÉS'>CONTEINER 20 PÉS</MenuItem>
                                                        <MenuItem value='DISTRIBUIDOR DE FERTILIZANTES'>DISTRIBUIDOR DE FERTILIZANTES</MenuItem>
                                                        <MenuItem value='ESCAVADEIRA VALETADEIRA'>ESCAVADEIRA VALETADEIRA</MenuItem>
                                                        <MenuItem value='ESPARGIDOR'>ESPARGIDOR</MenuItem>
                                                        <MenuItem value='FOOD TRUCK'>FOOD TRUCK</MenuItem>
                                                        <MenuItem value='GRADE BAIXA'>GRADE BAIXA</MenuItem>
                                                        <MenuItem value='GAIOLA DE GÁS'>GAIOLA DE GÁS</MenuItem>
                                                        <MenuItem value='GRANELEIRO'>GRANELEIRO</MenuItem>
                                                        <MenuItem value='GUINCHO MUNCK'>GUINCHO MUNCK</MenuItem>
                                                        <MenuItem value='GRUA CARROCERIA'>GRUA CARROCERIA</MenuItem>
                                                        <MenuItem value='PERFURATRIZ'>PERFURATRIZ</MenuItem>
                                                        <MenuItem value='PLATAFORMA'>PLATAFORMA</MenuItem>
                                                        <MenuItem value='PLATAFORMA GUINCHO'>PLATAFORMA GUINCHO</MenuItem>
                                                        <MenuItem value='POLIGUINDASTE'>POLIGUINDASTE</MenuItem>
                                                        <MenuItem value='ROLL ON OFF'>ROLL ON OFF</MenuItem>
                                                        <MenuItem value='SILO'>SILO</MenuItem>
                                                        <MenuItem value='SUINEIRA'>SUINEIRA</MenuItem>
                                                        <MenuItem value='TANQUE AÇO'>TANQUE AÇO</MenuItem>
                                                        <MenuItem value='TANQUE INOX'>TANQUE INOX</MenuItem>
                                                        <MenuItem value='TANQUE ISOTÉRMICO'>TANQUE ISOTÉRMICO</MenuItem>
                                                        <MenuItem value='TANQUE HIDRO VÁCUO'>TANQUE HIDRO VÁCUO</MenuItem>
                                                        <MenuItem value='TANQUE PIPA'>TANQUE PIPA</MenuItem>
                                                        <MenuItem value='TORA FLORESTAL'>TORA FLORESTAL</MenuItem>
                                                        <MenuItem value='TRANSBORDO CANAVIEIRO'>TRANSBORDO CANAVIEIRO</MenuItem>
                                                        <MenuItem value='TRIO ELÉTRICO'>TRIO ELÉTRICO</MenuItem>
                                                        <MenuItem value='VARREDEIRA'>VARREDEIRA</MenuItem>
                                                    </Select>
                                                    {error?.carroceria && (
                                                        <FormHelperText error>{error.carroceria}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {showFields && (
                                    <div className='row'>
                                        {showKm && (
                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='km'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: kmFocused ? 'primary.main' : '' }}
                                                        error={error?.km}
                                                    >
                                                        Km
                                                    </FormLabel>
                                                    <NumericFormat
                                                        required
                                                        id='km'
                                                        name='km'
                                                        customInput={TextField}
                                                        value={userForm.km}
                                                        thousandSeparator
                                                        suffix=' Km'
                                                        variant='outlined'
                                                        error={error?.km}
                                                        helperText={error?.km}
                                                        color={error?.km ? 'error' : 'primary'}
                                                        onValueChange={(values) => handleNumericInputChange(values, 'km')}
                                                        onFocus={() => setKmFocused(!kmFocused)}
                                                        onBlur={() => setKmFocused(!kmFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                        )}

                                        <div className='col'>
                                            <FormControl
                                                className='mb-4'
                                                fullWidth
                                            >
                                                <FormLabel
                                                    htmlFor='valor'
                                                    sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: valorFocused ? 'primary.main' : '' }}
                                                    error={error?.valor}
                                                >
                                                    Valor
                                                </FormLabel>
                                                <NumericFormat
                                                    required
                                                    id='valor'
                                                    name='valor'
                                                    customInput={TextField}
                                                    value={userForm.valor}
                                                    thousandSeparator
                                                    prefix='R$ '
                                                    variant='outlined'
                                                    error={error?.valor}
                                                    helperText={error?.valor}
                                                    color={error?.valor ? 'error' : 'primary'}
                                                    onValueChange={(values) => handleNumericInputChange(values, 'valor')}
                                                    onFocus={() => setValorFocused(!valorFocused)}
                                                    onBlur={() => setValorFocused(!valorFocused)}
                                                    disabled={isButtonDisabled}
                                                />
                                            </FormControl>
                                        </div>
                                    </div>
                                )}

                                {showFields && (
                                    <div className='row'>
                                        <div className='col'>
                                            <FormControl
                                                className='mb-4'
                                                fullWidth
                                            >
                                                <FormLabel
                                                    htmlFor='observacao'
                                                    sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: observacaoFocused ? 'primary.main' : '' }}
                                                    error={error?.observacao}
                                                >
                                                    Observação
                                                </FormLabel>
                                                <TextField
                                                    required
                                                    id='observacao'
                                                    name='observacao'
                                                    type='text'
                                                    rows={5}
                                                    multiline
                                                    variant='outlined'
                                                    error={error?.observacao}
                                                    helperText={error?.observacao}
                                                    color={error?.observacao ? 'error' : 'primary'}
                                                    slotProps={{ htmlInput: { maxLength: 600 } }}
                                                    onChange={handleChange}
                                                    onFocus={() => setObservacaoFocused(!observacaoFocused)}
                                                    onBlur={() => setObservacaoFocused(!observacaoFocused)}
                                                    disabled={isButtonDisabled}
                                                />
                                            </FormControl>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='card p-4 mt-0'>
                        <div className='imagesUpload mb-4'>
                            <h5 className='mb-4'>Imagens</h5>
                            <div className='imgUploadBox d-flex align-items-center'>
                                {previewURLs.map((url, index) => (
                                    <div key={index} className='uploadBox'>
                                        <Button
                                            className='remove'
                                            onClick={() => handleDeleteImage(index)}
                                            disabled={disableDeleteImg}
                                        >
                                            <MdClear />
                                        </Button>
                                        <div className='box'>
                                            <LazyLoadImage
                                                src={url}
                                                effect='blur'
                                                alt='Imagem'
                                                width={'100%'}
                                                height={'100%'}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className='uploadBox'>
                                    <input
                                        type='file'
                                        multiple
                                        accept='image/*'
                                        onChange={handleImageChange}
                                        disabled={isButtonDisabled}
                                    />
                                    <div className='info'>
                                        <MdImage />
                                        <p>Selecionar imagens</p>
                                    </div>
                                </div>
                            </div>
                            {error?.imagem &&
                                <p className='mt-3' style={{ color: '#d32f2f', fontSize: '12px' }}>{error?.imagem}</p>
                            }
                            {
                                uploadError &&
                                <p className='mt-3' style={{ color: '#d32f2f', fontSize: '12px' }}>{uploadError}</p>
                            }
                        </div>

                        <div className='d-flex justify-content-between'>
                            <Button
                                color='error'
                                variant='contained'
                                onClick={() => navigate('/dashboard')}
                                disabled={isButtonDisabled}
                            >
                                Cancelar
                            </Button>

                            <Button
                                type='submit'
                                variant='contained'
                                sx={{ color: '#fff' }}
                                // disabled={!showFields}
                                loading={isButtonDisabled}
                            >
                                Salvar
                            </Button>
                        </div>
                    </div>
                </Box>
            )}
        </>
    )
}

export default DashboardNovoAnuncioFTP;